"use client";
import React, { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';
import CrescentMoon from './CrescentMoon';
import GeometricPattern from './GeometricPattern';
import { COMPANY } from '../data/mock';
import { brandConfig } from '../brandConfig';

export default function LoadingScreen() {
  const [show, setShow] = useState(() => !sessionStorage.getItem('hijra_loaded'));
  const screenRef = useRef(null);
  const logoRef = useRef(null);
  const titleRef = useRef(null);
  const subRef = useRef(null);
  const barRef = useRef(null);

  useEffect(() => {
    if (!show) return;
    const tl = gsap.timeline();
    tl.fromTo(logoRef.current, { scale: 0.6, opacity: 0 },
      { scale: 1, opacity: 1, duration: 0.7, ease: 'back.out(1.4)' }, 0.3);
    tl.fromTo(titleRef.current, { y: 20, opacity: 0, filter: 'blur(8px)' },
      { y: 0, opacity: 1, filter: 'blur(0px)', duration: 0.6, ease: 'power3.out' }, 1.0);
    tl.fromTo(subRef.current, { opacity: 0, y: 10 },
      { opacity: 1, y: 0, duration: 0.5 }, 1.4);
    tl.fromTo(barRef.current, { scaleX: 0, transformOrigin: 'left' },
      { scaleX: 1, duration: 1.2, ease: 'power2.inOut' }, 1.8);
    tl.to(screenRef.current, {
      yPercent: -100, duration: 0.8, ease: 'power3.inOut', delay: 0.3,
      onComplete: () => {
        sessionStorage.setItem('hijra_loaded', '1');
        setShow(false);
      },
    });
  }, [show]);

  if (!show) return null;

  return (
    <div ref={screenRef} style={{
      position: 'fixed', inset: 0, background: '#0A1628', zIndex: 9999,
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', overflow: 'hidden',
    }}>
      <GeometricPattern color="#C9A84C" opacity={0.06} size={100} animate />
      <div ref={logoRef} style={{ opacity: 0, zIndex: 2 }}>
        <img src="/logo.png" alt={brandConfig.companyName} style={{ height: 130, width: 'auto', objectFit: 'contain' }} />
      </div>
      <div style={{ marginTop: 24, zIndex: 2 }}>
        <CrescentMoon size={50} color="#C9A84C" animate delay={0.4} />
      </div>
      <div ref={titleRef} style={{ opacity: 0, zIndex: 2, marginTop: 8 }}>
        <div style={{
          fontFamily: 'Amiri, serif', fontSize: 34, fontWeight: 700,
          color: '#C9A84C', letterSpacing: '0.12em', textAlign: 'center',
        }}>
          {brandConfig.companyName.toUpperCase()}
        </div>
      </div>
      <div ref={subRef} style={{ opacity: 0, marginTop: 12, zIndex: 2 }}>
        <div className="arabic-text" style={{
          fontSize: 22, color: 'rgba(251,248,240,0.85)', textAlign: 'center',
        }}>
          {COMPANY.arabicName}
        </div>
        <div style={{
          fontFamily: 'Inter', fontSize: 11, color: 'rgba(201,168,76,0.7)',
          textAlign: 'center', marginTop: 10, letterSpacing: '0.3em', textTransform: 'uppercase',
        }}>
          Spirituality · Comfort · Trust
        </div>
      </div>
      <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: 3, background: 'rgba(201,168,76,0.2)' }}>
        <div ref={barRef} style={{ height: '100%', background: '#C9A84C', transformOrigin: 'left' }} />
      </div>
    </div>
  );
}
